import { Component, OnInit, ViewChild } from '@angular/core';
import { AngularFireAuth } from '@angular/fire/auth';
import { Router } from '@angular/router';
import { AuthenticationService } from '../shared/authentication.service';
import { ApiService } from '../shared/api.service';
import { MatSelect, MatSelectChange } from '@angular/material/select';
import { FormControl } from '@angular/forms';
import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, map, startWith } from 'rxjs/operators';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { CacheService } from '../shared/cache.service';

@Component({
  selector: 'app-location-list',
  templateUrl: './location-list.component.html',
  styleUrls: ['./location-list.component.css']
})
export class LocationListComponent implements OnInit {

  userData;
  userRole;
  idToken;
  uid;
  userOrgData;
  userSavedPlaces;
  userSavedWaterSources;
  userTests;
  loaded = false;
  markerOptions = {
    animation: google.maps.Animation.DROP,
    icon: './assets/icon.png'
  };
  locationsToDisplay: Array<any>;
  testTypesList: string[] = ['Bacteria', 'Lead', 'Chlorine', 'Ecoli', 'C19', 'H2O2'];
  testFilters: Array<any>;
  startDateFilter;
  endDateFilter;
  testTypes = new FormControl();
  searchTerm$ = new Subject<string>();
  searchTermSubscription: Subscription;
  orgControl = new FormControl();
  options = [];
  filteredOptions: Observable<any[]>;

  @ViewChild('typeSelect') typeSelect: MatSelect;


  constructor(private angularFireAuth: AngularFireAuth, private apiService: ApiService, private router: Router, private authenticationService: AuthenticationService, private cacheService: CacheService) {
    this.searchTermSubscription = this.searchTerm$.pipe(
      debounceTime(100))
      .subscribe(term => {
        this.searchItems(term);
      });
  }

  ngOnInit(): void {

    this.angularFireAuth.authState.subscribe(async user => {
      if (user && user.uid) {

        this.userData = this.authenticationService.userData;
        this.userRole = this.authenticationService.userRole;
        this.uid = this.userData.uid;
        const token = await user.getIdTokenResult();
        this.idToken = token.token;
        console.log(this.userData, this.userRole, this.uid, this.idToken);
        if (this.cacheService.locationListCached) {
          this.getCache();
        } else {
          await this.getUserSavedData();
          if (this.userRole === 'superuser') {
            await this.getAllOrgs();
            this.filteredOptions = this.orgControl.valueChanges
              .pipe(
                startWith(''),
                map(value => typeof value === 'string' ? value : value.name),
                map(name => name ? this._filter(name) : this.options.slice())
              );
          }
          this.setCache();
        }

      } else {
        await this.router.navigate(['/']);
      }
    });


  }

  private async getUserSavedData(viewingOrgId?: string) {

    const userData = await this.apiService.getUserData(this.uid, this.idToken);

    const filters = {filters: {uid: this.uid}};
    console.log(filters, this.uid);
    this.userTests = await this.apiService.getTestData(filters, this.idToken);
    console.log(this.userTests);
    const userCustomClaims = await this.apiService.getUserCustomClaims(this.idToken, this.uid);

    const userOrgId = viewingOrgId || userCustomClaims.orgData?.orgId;
    this.userOrgData = await this.apiService.getOrgData(this.idToken, userOrgId);
    if (!viewingOrgId || (viewingOrgId && userOrgId !== viewingOrgId)) {

      this.userSavedPlaces = userData.data.places ? userData.data.places : [];
      this.userSavedPlaces = this.userSavedPlaces.filter(place => typeof place.time_created === 'number').sort((a, b) => b.time_created - a.time_created);
    } else {
      this.userSavedPlaces = [];
    }
    // console.log(this.locationsToDisplay, this.userSavedPlaces);
    this.userSavedWaterSources = userData.data.waterSources ? userData.data.waterSources : [];
    if (this.userRole === 'admin' && this.userOrgData.sharingLocations || this.userRole === 'superuser') {

      const userList = await this.apiService.getOrgUsers(this.idToken, userOrgId);

      const orgPlacesArray = [];
      const orgWaterSourcesArray = [];
      for (const orgUser of userList) {
        if (orgUser.userData?.uid !== this.uid) {
          const places = orgUser.userData?.places;
          const sources = orgUser.userData?.waterSources;
          if (places) {
            orgPlacesArray.push(places);
          }
          if (sources) {
            orgWaterSourcesArray.push(sources);
          }
          const testFilters = {filters: {uid: orgUser.userData?.uid}};
          const orgUserTests = await this.apiService.getTestData(testFilters, this.idToken);
          console.log(this.userTests);
          this.userTests.data = this.userTests.data.concat(orgUserTests.data);
        }
      }

      for (const orgPlaces of orgPlacesArray) {
        this.userSavedPlaces = this.userSavedPlaces.concat(orgPlaces);
      }
      for (const orgSources of orgWaterSourcesArray) {
        this.userSavedWaterSources = this.userSavedWaterSources.concat(orgSources);
      }

      console.log(this.userSavedPlaces);
    }

    for (const place of this.userSavedPlaces) {
      place.numberOfSources = this.userSavedWaterSources.filter(source => source.place_id === place.place_id).length;
      console.log(this.userTests);
      const currentLocationTests = this.userTests.data.filter(test => test.location && test.location.place_id === place.place_id);
      place.numberOfTests = currentLocationTests.length;
      place.lastTested = currentLocationTests.length > 0 ? new Date(currentLocationTests.sort((a, b) => b.calculationResult.date?._seconds - a.calculationResult.date?._seconds)[0].calculationResult.date._seconds * 1000).toLocaleDateString('en-US') : 'N/A';

    }
    this.locationsToDisplay = this.userSavedPlaces;

    this.loaded = true;

  }

  async navigateToLocation(place: any) {
    await this.router.navigate(['/location/' + place.place_id], {state: {place}});
  }

  filterTestTypes($event: MatSelectChange) {
    this.testFilters = $event.value.map(filter => filter.toLowerCase());
    this.filterDisplayedLocations();
    console.log(this.testFilters);
  }

  filterDisplayedLocations() {
    this.locationsToDisplay = this.userTests;
    if (this.testFilters?.length > 0) {
      this.locationsToDisplay = this.userTests.filter(test => {
        return this.testFilters.includes(test.calculationResult.testType.toLowerCase());
      });
    }

    if (this.startDateFilter) {
      this.locationsToDisplay = this.locationsToDisplay.filter(test => {
        console.log(this.startDateFilter, test.calculationResult.date._seconds);
        return test.calculationResult.date._seconds >= this.startDateFilter;
      });

    }
    if (this.endDateFilter) {
      this.locationsToDisplay = this.locationsToDisplay.filter(test => {
        console.log(this.endDateFilter, test.calculationResult.date._seconds);
        return test.calculationResult.date._seconds <= this.endDateFilter;
      });

    }
  }

  handleStartDateChange($event: Event) {
    console.log('here');
    const target = $event.target as HTMLInputElement;
    this.startDateFilter = target.valueAsNumber / 1000;
    console.log(this.startDateFilter);
    const endDateInput = document.getElementById('end') as HTMLInputElement;
    endDateInput.setAttribute('min', target.value);
    this.filterDisplayedLocations();
  }

  handleEndDateChange($event: Event) {
    console.log('here');
    const target = $event.target as HTMLInputElement;
    this.endDateFilter = target.valueAsNumber / 1000;
    console.log(this.endDateFilter);
    const endDateInput = document.getElementById('start') as HTMLInputElement;
    endDateInput.setAttribute('max', target.value);
    this.filterDisplayedLocations();
  }

  clearFilters() {
    this.startDateFilter = undefined;
    this.endDateFilter = undefined;
    this.testFilters = [];
    const startDateInput = document.getElementById('start') as HTMLInputElement;
    const endDateInput = document.getElementById('end') as HTMLInputElement;
    if (startDateInput) {
      startDateInput.setAttribute('max', '');
      startDateInput.value = '';

    }
    if (endDateInput) {
      endDateInput.setAttribute('min', '');
      endDateInput.value = '';

    }
    this.typeSelect.value = '';
    this.filterDisplayedLocations();
  }

  updateSearchTerm($event) {
    this.searchTerm$.next($event.target.value);
  }

  searchItems(value) {
    const filterValue = value;
    this.locationsToDisplay = this.userSavedPlaces;
    // this.filterDisplayedItems();
    // console.log(this.itemsToDisplayFiltered, filterValue);
    this.locationsToDisplay = this.locationsToDisplay.filter(place => {
      return (
        place.name?.toLowerCase().includes(filterValue.toLowerCase()) ||
        place.formatted_address?.toLowerCase().includes(filterValue.toLowerCase())
      );
    });


  }

  orgDisplayFn(org): string {
    return org && org.name ? org.name : '';
  }

  private _filter(name: string) {
    const filterValue = name.toLowerCase();

    return this.options.filter(option => option.name.toLowerCase().indexOf(filterValue) === 0);
  }

  private async getAllOrgs() {
    this.options = await this.apiService.getAllOrgs(this.idToken);
  }

  async changeViewingOrg($event: MatAutocompleteSelectedEvent) {
    this.loaded = false;
    await this.getUserSavedData($event.option.value.id);

  }

  private getCache() {
    this.options = this.cacheService.options;
    this.locationsToDisplay = this.cacheService.locationsToDisplay;
    this.userSavedPlaces = this.cacheService.userSavedPlaces;
    this.userTests = this.cacheService.userTests;
    this.userOrgData = this.cacheService.userOrgData;
    this.testFilters = this.cacheService.testFilters;
    this.filteredOptions = this.cacheService.filteredOptions;

    this.loaded = true;
  }

  private setCache() {
    this.cacheService.options = this.options;
    this.cacheService.locationsToDisplay = this.locationsToDisplay;
    this.cacheService.userSavedPlaces = this.userSavedPlaces;
    this.cacheService.userTests = this.userTests;
    this.cacheService.userOrgData = this.userOrgData;
    this.cacheService.testFilters = this.testFilters;
    this.cacheService.locationListCached = true;
  }
}
